import qs from "qs";
import axios from "axios";

axios.defaults.baseURL = "https://8bp.shotgunstudio.com";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
// Project constant
const project = {
  type: "Project",
  id: 86
};

// Authentication

const logInWithPassword = function (loginInfo) {
  const data = {
    ...loginInfo,
    grant_type: "password"
  };

  return axios.post("/api/v1/auth/access_token", qs.stringify(data));
};

const renewToken = function (refreshToken) {
  const data = {
    refresh_token: refreshToken,
    grant_type: "refresh"
  };
  return axios.post("/api/v1/auth/access_token", qs.stringify(data));
};

// Asset Upload

const findAssetOrShotByName = function (name) {
  const firstCharacter = name.charAt(0);
  // If a the entity name starts with a number, it is a shot. otherwise it's an asset.
  const endPoint = isNaN(firstCharacter) ?
    `/api/v1/entity/asset?filter[code]=${name}` :
    `/api/v1/entity/shot?filter[code]=${name}`;

  return new Promise((resolve, reject) => {
    axios
      .get(endPoint)
      .then(res => {
        const data = res.data.data;
        if (data.length == 0) reject("no record found");
        resolve(data[0]);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const findTaskByName = function (entityData, taskName) {
  const headers = {
    "Content-Type": "application/vnd+shotgun.api3_array+json"
  };
  const body = {
    filters: [
      [
        "entity",
        "is",
        {
          type: entityData.type,
          id: entityData.id
        }
      ],
      ["content", "is", taskName]
    ]
  };

  return new Promise((resolve, reject) => {
    axios
      .post("/api/v1/entity/task/_search", body, {
        headers
      })
      .then(res => {
        const data = res.data.data;
        if (data.length == 0) reject("no record found");
        resolve(data[0]);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const createVersionEntity = function (versionName, entityData, taskData) {
  const data = {
    project,
    code: versionName,
    // description: "Upload Test",
    sg_status_list: "rev",
    entity: {
      type: entityData.type,
      id: entityData.id
    },
    sg_task: {
      type: taskData.type,
      id: taskData.id
    }
  };
  return axios.post("/api/v1/entity/version", data, {
    headers: {
      "Content-Type": "application/json"
    }
  });
};

const uploadToShotgun = function (entityData, file, onUploadProgress) {
  let uploadInfo = {};
  return new Promise((resolve, reject) => {
    // Step 1: Obtain an upload link
    axios
      .get(
        `/api/v1/entity/${entityData.type}/${
          entityData.id
        }/sg_uploaded_movie/_upload?filename=${file.name}`
      )
      .then(res => {
        uploadInfo = res.data;
        // Step 2: upload file to record
        let formData = new FormData();
        formData.append("link", uploadInfo.links.upload);
        formData.append("file", file.raw);

        const debugMode = process.env.NODE_ENV == "development";
        let uploadEndpoint = debugMode ?
          "http://localhost:3000/api/upload" :
          "https://shotgun-uploader-prod.herokuapp.com/api/upload";
        return axios({
          method: "post",
          url: uploadEndpoint,
          baseURL: "",
          config: {
            onUploadProgress: onUploadProgress,
            transformRequest: [
              (data, headers) => {
                delete headers.common.Authorization;
                headers.common["Content-Type"] = "multipart/form-data";
                return data;
              }
            ]
          },
          data: formData
        });
      })
      .then(
        // Step 3: link the upload to a record
        res => {
          let updatedUploadInfo = uploadInfo.data;
          if (res.data) {
            updatedUploadInfo = {
              ...uploadInfo.data,
              ...res.data.data
            };
          }
          return axios.post(
            uploadInfo.links.complete_upload, {
              upload_info: updatedUploadInfo,
              upload_data: {}
            }, {
              headers: {
                "Content-Type": "application/json"
              },
              params: {
                filename: file.name
              }
            }
          );
        }
      )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const createPlaylist = function (versions, playlistName) {
  return new Promise((resolve, reject) => {
    // 1 Create a playlist with the versions just uploaded
    //   Name the playlist according to the naming convention
    //   Date | Submitter | Asset Name | Task | Topic
    //   Add the new versions in the submission to the playlist

    const data = {
      project,
      code: playlistName,
      versions: versions
    };

    let playlistData;

    return axios
      .post("/api/v1/entity/playlist", data, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        // 2. Create a note in shotgun
        // Set the submission type of the note to “Submission”
        // Set the subject to match the name of the playlist (Date | Submitter | Description )
        // Add a “submission note” with the submission
        playlistData = res.data.data;
        const noteData = {
          project,
          subject: playlistName,
          sg_note_category: "Submission",
          content: "Created for playlist " + playlistName,
          playlist: playlistData,
          note_links: [playlistData, ...versions]
        };

        return axios.post("/api/v1/entity/note", noteData, {
          headers: {
            "Content-Type": "application/json"
          }
        });
      })
      .then(res => {
        resolve({
          playlist: playlistData,
          note: res.data.data
        });
      })
      .catch(error => reject(error));
  });
};

const createPublishEvent = function (versions) {
  // 4. Create a publish event
  // Add a link to the versions that were created
  return new Promise((resolve, reject) => {
    const data = {
      project,
      code: name,
      versions: versions
    };

    return (
      axios
      .post("/api/v1/entity/version", data, {
        headers: {
          "Content-Type": "application/json"
        }
      })

      // 4. Create a publish event
      // Add a link to the versions that were created
      .catch(error => reject(error))
    );
  });
};

const mocks = {
  "user/me": {
    GET: {
      name: "doggo",
      title: "sir"
    }
  }
};

const apiCall = ({
    url,
    method
  }) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(mocks[url][method || "GET"]);
      } catch (err) {
        reject(new Error(err));
      }
    }, 1000);
  });

export default apiCall;
export {
  logInWithPassword,
  renewToken,
  findAssetOrShotByName,
  findTaskByName,
  createVersionEntity,
  uploadToShotgun,
  createPlaylist
};